module.exports = __webpack_public_path__ + "img/47.fc98c630.png";